import { getEmployees } from "src/redux/api/_hr.api";
import { Filters } from "./useFetchArchives";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Employee } from "src/redux/types/_employee.type";

export const employeeKeys = ({
  all: ["hr-employees"] as const,
  list: (filters: Filters) => [
    ...employeeKeys.all, "list", filters
  ] as const
})

export const useEmployees = (filters: Filters) => {
  return useQuery<Employee[]>({
    queryKey: employeeKeys.list(filters),
    queryFn: () =>  getEmployees(filters),
    placeholderData: keepPreviousData,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
